module.exports = __webpack_public_path__ + "img/subscription.34eaf0cf.png";